/**
 * This error is thrown when the server returns an invalid HTTP response, such as
 * a 500 error or a response that doesn't have the correct content-type.
 *
 * These errors do not need to be reported to Sentry, since our server-side error
 * monitoring should cover these cases.
 */
export class EchoServerError extends Error {
  public status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'EchoServerError';
    this.status = status;
  }
}

export function assert(condition: unknown, error: string | Error): asserts condition {
  if (!condition) throw typeof error === 'string' ? new Error(error) : error;
}
